import { useSquareWebSdk } from "@hooks/integrations/useSquareWebSdk";
import IOrder from "@models/IOrder";
import { useRef } from "react";
import { useState } from "react";
import { Formik } from "formik";
import { useEffect } from "react";
import { CreditCard, PaymentForm } from "react-square-web-payments-sdk";

type Props = {
    orderModel: IOrder;
};

export const OrderPaymentSquareNewCard = (props: Props) => {
    const initalized = useRef(false);

    const environment = process.env.NODE_ENV === "development" ? "sandbox" : "production";

    // const card = useSquareWebSdk({environment, initialized: initalized.current});

    initalized.current = true;

    // useEffect(() => {
    //     console.log("card", card);
    //     // @ts-ignore
    //     if (card) {
    //         // @ts-ignore
    //         // card.on('cardNonceGenerated', (nonce: string) => {
    //         //     console.log("cardNonceGenerated", nonce);
    //         // });
    //     }
    // }, [card]);

    if (!process.env.PUBLIC_SQUARE_APP_ID) {
        return null;
    }

    return (
        <div className={"OrderPaymentSquareNewCard"}>
            <PaymentForm
                applicationId={process.env.PUBLIC_SQUARE_APP_ID}
                locationId={"L89WQCEB68YK6"}
                cardTokenizeResponseReceived={(response) => {
                    console.log("cardTokenizeResponseReceived", response);
                }}
                createVerificationDetails={() => {
                    return {
                        amount: "100.00",
                        billingContact: {
                            addressLines: ["123 Main St", "Apt 1"],
                            familyName: "Doe",
                            givenName: "John",
                            countryCode: "US",
                            city: "Henderson",
                        },
                        currencyCode: "USD",
                        intent: "CHARGE",
                    };
                }}>
                <CreditCard />
            </PaymentForm>
            {/* <Formik
            initialValues={{
                cardNumber: "",
                expirationDate: "",
                cvv: "",
            }}
            onSubmit={(values) => {
                console.log(values, card);
            }}
        >
            {({values, handleChange, handleSubmit}) => (
                <form onSubmit={handleSubmit}>
                    <div id="card-container"></div>
                    <button id="card-button" type="button">Pay $1.00</button>
                </form>
                
            )}
        </Formik>

        <div id="payment-status-container"></div> */}
        </div>
    );
};
